export default chord => chord && chord.displayName.replace("chord", "")
